import { Buffer } from 'buffer';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';

export const ENDPOINT_HOST = process.env.GRAPHQL_BASE_URL || '';
export const ENDPOINT_PATH = '/directory/v2/gql';
export const ENDPOINT = `${ENDPOINT_HOST}${ENDPOINT_PATH}`;

const getXZData = () => {
    if (typeof window !== 'undefined') {
        return window.btoa(JSON.stringify({ host: window.location.host }));
    }

    return Buffer.from(JSON.stringify({ host: 'www.zocdoc.com' })).toString(
        'base64'
    );
};

const link = createHttpLink({
    headers: {
        'X-ZData': getXZData(),
    },
    credentials: 'same-origin',
    fetch: fetchWithRetries,
    fetchOptions: { retries: 1 },
    uri: ENDPOINT,
});

const cache = new InMemoryCache();
if (typeof window !== 'undefined') {
    cache.restore(window.__APOLLO_STATE__);
}

export default new ApolloClient({
    cache,
    connectToDevTools: process.env.NODE_ENV === 'development',
    link,
    ssrMode: typeof window === 'undefined',
});
